import Swal from "sweetalert2";
import {
  LOGIN,
  MYBUSINESSADD,
  RESENDOTP,
  SENDOTP,
  VALIDATEUSEROTP,
} from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const LoginApi = async (params) => {
  console.log("login api");
  const res = await axios.post(LOGIN, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return res;
};

export const getOtp = (payload, callback) => {
  axios
    .post(SENDOTP, payload)
    .then((res) => {
      callback(res);
      if (res?.status) {
        Swal.fire({
          title: "Successfully Send Otp",
          // text: val.text,
          icon: "success",

          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          title: res.message,
          // text: val.text,
          icon: "warning",

          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log("err ", err);
    });
};

export const getresemndOtp = (payload, callback) => {
  axios
    .post(RESENDOTP, payload)
    .then((res) => {
      callback(res);
      if (res?.status) {
        Swal.fire({
          title: "Successfully Resent Otp",
          // text: val.text,
          icon: "success",

          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          title: res.message,
          // text: val.text,
          icon: "warning",

          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log("err ", err);
    });
};

export const getValidateOtp = (payload, callback) => {
  axios
    .post(VALIDATEUSEROTP, payload)
    .then((res) => {
      callback(res);
      if (res?.status) {
        Swal.fire({
          title: "Successfully Resent Otp",
          // text: val.text,
          icon: "success",

          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          title: res.message,
          // text: val.text,
          icon: "warning",

          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log("err ", err);
    });
};

// /.businessid
// export const  = async (params) => {
//   console.log("login api");
//   const res = await axios.post(, params, {
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
//   return res;
// };
export const MyBusinessAddApi = async (payload, callback) => {
  // validation(payload)
  await axios
    .post(MYBUSINESSADD, payload)
    .then((res) => {
      console.log("bUSINESS ADD ", res);

      callback(res);
      // if (res?.data?.succeeded) {
      //   Swal.fire({
      //     text: "Successfully added",
      //     icon: "success",
      //     ...swalAlertPopProps,
      //   });
      // } else {
      //   Swal.fire({
      //     text: res?.data?.message,
      //     icon: "error",
      //     ...swalAlertPopProps,
      //   });
      // }
    })
    .catch((err) => {
      console.log(err);
      // Swal.fire({
      //   text: JSON.stringify(err),
      //   icon: "success",
      //   ...swalAlertPopProps,
      // });
    });
};
